import { render, staticRenderFns } from "./SendCallForFunds.vue?vue&type=template&id=ee45dd36"
import script from "./SendCallForFunds.vue?vue&type=script&lang=js"
export * from "./SendCallForFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports